module.exports = {"ja":{},"en":{}}


//////////////////
// WEBPACK FOOTER
// ./src/message.json
// module id = 7kxo
// module chunks = 11